import { useMemo } from "react";
import { Controller } from "react-hook-form";
import { v4 as uuidv4 } from "uuid";
import { FieldProps } from "modules/record/record-producer/types/record-producer-types";
import { TranslatableTextFieldInput } from "modules/record/shared/fields/TranslatableTextFieldInput";
import { buildRequiredRule, getRequiredFieldMessage } from "../../services/recordProducerValidation";
import { BaseField } from "./BaseField";
import { useRecordProducer } from "../RecordProducerContext";

const sanitizeKeyPart = (value: string) => String(value || "")
    .trim()
    .replace(/[^a-zA-Z0-9_-]+/g, "_")
    .replace(/^_+|_+$/g, "");

export const TranslatableTextFieldComponent = ({ column, control, baseFieldProps, runtimeProps }: FieldProps) => {
    const recordProducer = useRecordProducer();
    const generatedKeySuffix = useMemo(() => uuidv4(), []);
    const recordKeyPart = sanitizeKeyPart(recordProducer.recordId || generatedKeySuffix);
    const suggestedKey = `record.${recordProducer.table.name}.${column.name}.${recordKeyPart}`;

    return (
        <BaseField column={column} required={runtimeProps?.required} hidden={runtimeProps?.hidden} {...baseFieldProps} as="group">
            <Controller
                name={column.name}
                control={control}
                defaultValue={column.default_value || ""}
                rules={{ required: buildRequiredRule(runtimeProps?.required ?? column.is_mandatory, getRequiredFieldMessage(column)) }}
                render={({ field, fieldState }) => (
                    <TranslatableTextFieldInput
                        label={column.label || column.name}
                        value={field.value ?? ""}
                        onChange={field.onChange}
                        disabled={runtimeProps?.readonly}
                        suggestedKey={suggestedKey}
                        translationKey={recordProducer.translationKeys?.[column.name]}
                        commitMode="record"
                        defaultPublic={Boolean(column.translation_public)}
                        error={!!fieldState.error}
                        helperText={fieldState.error?.message || runtimeProps?.helperText}
                    />
                )}
            />
        </BaseField>
    );
};
